import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import { AppBar, Toolbar, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import * as PaymentActions from "../actions/PaymentActions";

import Cart from "../components/Cart";
import PaymentPlans from "../components/PaymentPlans";

const styles = theme => ({
  root: {
    display: 'grid'
  },
  toolbar: {
    paddingTop: '5px'
  },
  title: {
    flexGrow: 1
  },
  backIconContainer: {
    paddingRight: "2.7vw",
    cursor: "pointer",
    display: "grid",
    "& img": {
      width: "0.7em"
    }
  },
  logoContainer: {
    textAlign: "center",
    position: "absolute",
    left: "calc(50% - 8px)",
    top: "calc(50% - 10px)",
    
    "& img": {
      width: "1.7em"
    }
  }
});

const TviToolbar = withStyles({
  root: {
    display: "grid",
    gridTemplateColumns: "1fr  max-content max-content",
    position: "relative",
  },
})(Toolbar);

class Header extends Component {
  render = () => {
    const { props } = this;
    const { classes, orderId } = props;
    return (
      <AppBar position="static" className={classes.root}>
        <TviToolbar className={classes.toolbar}>
          <Typography className={classes.title} variant="h5" noWrap>
            Checkout
          </Typography>
          <div className={classes.logoContainer}>
            <img src="/media/logo.svg" alt="Tvi logo" />
          </div>
          <Cart />
          {orderId ? <PaymentPlans /> : null}
        </TviToolbar>
      </AppBar>
    );
  };
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({ payment, paymentPlanReducer }) => ({
  step: payment.step,
  userDetails: payment.userDetails,
  orderId: paymentPlanReducer.orderId,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(PaymentActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Header));

